import notFoundImage from "@assets/images/what.svg";
import { Grid } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import useAppState from "@saleor/hooks/useAppState";
import useNavigator from "@saleor/hooks/useNavigator";
import { Button } from "@saleor/macaw-ui";
import React, { ReactNode, useEffect } from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

import useStyles from "./styles";

export interface TimeOutPageProps {
  timeOutText?: ReactNode | string;
}

const TimeOutPage: React.FC<TimeOutPageProps> = ({ timeOutText }) => {
  const classes = useStyles();
  const intl = useIntl();
  const navigate = useNavigator();
  const [_, dispatchAppState] = useAppState();

  useEffect(() => {
    dispatchAppState({
      type: "setFullScreen",
      payload: {
        value: true
      }
    });
    return () => {
      dispatchAppState({
        type: "setFullScreen",
        payload: {
          value: false
        }
      });
    };
  }, []);

  const handleGoDashboard = () => {
    navigate("/");
  };

  return (
    <div className={classes.root} data-testid="timeOutPage">
      <Grid container spacing={1} alignItems={"center"} justify={"center"}>
        <Grid item xs={12} md={4}>
          <SVG className={classes.notFoundImage} src={notFoundImage} />
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <MyTypography variant={"h1"}>
              {intl.formatMessage({ defaultMessage: "Process Timeout" })}
            </MyTypography>
            <MyTypography variant={"h1"} className={classes.timeOutText}>
              {timeOutText}
            </MyTypography>
          </div>
          <div className={classes.buttonContainer}>
            <Button variant="primary" onClick={handleGoDashboard}>
              {intl.formatMessage({ defaultMessage: "Dashboard" })}
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
TimeOutPage.displayName = "TimeOutPage";
export default TimeOutPage;
